<template>
  <div>
    <v-menu
      ref="dateMenu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="dateValue"
      transition="scale-transition"
      offset-y
      min-width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateValue"
          :disabled="disabled"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on" />
      </template>
      <v-date-picker
        v-model="dateValue"
        :readonly="!editable"
        no-title
        scrollable>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="menu = false">
          ยกเลิก
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="returnValue">
          ยืนยัน
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      editable: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        dateValue: new Date().toISOString().substr(0, 10),
        menu: false
      }
    },
    watch: {
      default: {
        handler (val) {
          this.dateValue = val
        }
      }
    },
    mounted () {
      this.dateValue = this.value ? this.value : new Date().toISOString().substr(0, 10)
    },
    methods: {
      returnValue () {
        this.$refs.dateMenu.save(this.dateValue)
        this.$emit('input', this.dateValue)
      }
    }

  }
</script>
